export default __webpack_public_path__ + "static/2. Parent Engagement at Your Fingertips 2-cc24762dfea0643845016f93fd44379d.png";